import { ReactNode } from 'react';
import { Provider } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';

export let _createSliceConfig: any;
export let _store: any;

type Props = {
  listReducers: object | undefined;
  children: ReactNode;
};

export function CombineReducerInitializer(props: Props) {
  _createSliceConfig = props.listReducers;
  const store = configureStore({
    reducer: _createSliceConfig,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({
        serializableCheck: false,
      });
    },
  });

  _store = store;

  return (
    <>
      <Provider store={store}>{props.children}</Provider>
    </>
  );
}
